<form [formGroup]="forgotForm" (ngSubmit)="forgotFormSubmit()" novalidate>
  <tc-form-group>
    <tc-input [placeholder]="'Email'" [type]="'email'" formControlName="email"></tc-input>
    <tc-form-description
      [tcColor]="'#e24d4d'"
      *ngIf="forgotForm.controls.email.touched && forgotForm.controls.email.invalid">
      Enter valid Email
    </tc-form-description>
  </tc-form-group>

  <div class="actions d-flex justify-content-between">
    <button
        tc-button
        [view]="'accent'"
        [disabled]="forgotForm.invalid"
        [load]="forgotLoginForm"
      >
        Submit
    </button>
    <button
        tc-button
        [view]="'accent'"
        [routerLink]="['../', 'sign-in']"
      >
        Go back
    </button>
  </div>
</form>
  